import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleRight } from '@fortawesome/free-solid-svg-icons'
import { useContext } from 'react'
import SettingsContext from '../contexts/SettingsContext'

function SettingsCard({ icon, name, isArrowed, isActive }) {
   return (
      // ${isActive && 'innerTabActive'}
      <div className={`settingsCard ${isActive && 'settingsCardActive'}`}>
         <div className={`settingsCard_icon`}>
            <FontAwesomeIcon icon={icon} className="settingsCard_icon_image" />
         </div>
         <div className="settingsCard_name">{name}</div>
         {isArrowed && (
            <div className={`settingCard_right`}>
               <FontAwesomeIcon icon={faAngleRight} className="" />
            </div>
         )}
      </div>
   )
}
export default SettingsCard
